import cx from 'classnames';

// @ts-expect-error - no TypeScript definitions yet
import { ErrorMessage } from 'src/components/ErrorMessage';
// @ts-expect-error - no TypeScript definitions yet
import { InfiniteScrollLoader } from 'src/components/InfiniteScrollLoader';
import { LayoutContainerCentered } from 'src/components/LayoutContainerCentered';
// @ts-expect-error - no TypeScript definitions yet
import { TableProjects } from 'src/components/TableProjects';
import { type ReviewerProjectListItem, TABLE_PROJECT_ACTIONS } from 'src/data/project';
import { useHistory } from 'src/lib/hooks/useHistory';
import { ROUTES } from 'src/routes';
import { ReviewerNavigationBar } from 'src/views/ReviewerNavigationBar';

import styles from './ReviewerDashboardPage.module.scss';
import { useActions } from './store';
import { useViewState } from './useViewState';

interface ReviewerDashboardPageProps {
  className?: string;
  accountName: string;
}

/** A reviewer's home page: the projects shared with them in the current account. */
export const ReviewerDashboardPage = ({ className, accountName }: ReviewerDashboardPageProps) => {
  const history = useHistory();
  const actions = useActions();
  const { projects, hasNextPage, loading, loadingMore, error, loadMoreError } = useViewState();

  const handleProjectAction = (action: string, project: ReviewerProjectListItem) => {
    if (action === TABLE_PROJECT_ACTIONS.click) {
      history.push(`${ROUTES.PROJECTS}/${project.id}`);
    }
  };

  const renderContent = () => {
    if (error) {
      return (
        <ErrorMessage
          className={styles.message}
          error="Couldn’t load the projects. Please try again later."
        />
      );
    }
    if (!loading && projects.length === 0) {
      return <p className={styles.message}>No projects for review</p>;
    }
    return (
      <>
        <TableProjects
          className={styles.table}
          projects={projects}
          loading={loading}
          onProjectAction={handleProjectAction}
          hideActions
          hideSort
          nameOnly
        />
        {!loading && hasNextPage && (
          <InfiniteScrollLoader
            loading={loadingMore}
            onLoadMore={actions.loadMoreProjects}
          />
        )}
        {loadMoreError && (
          <ErrorMessage
            className={styles.message}
            error="Couldn’t load more projects. Please try again later."
          />
        )}
      </>
    );
  };

  return (
    <div className={cx(styles.root, className)}>
      <ReviewerNavigationBar />

      <LayoutContainerCentered data-testid="ReviewerDashboardPage">
        <h1 className={styles.title}>Projects</h1>
        <p
          className={styles.account}
          data-testid="reviewerDashboardAccountName"
        >
          {accountName}
        </p>
        {renderContent()}
      </LayoutContainerCentered>
    </div>
  );
};
